(function dateControlDefinition(global) {
  "use strict";

  // Шаблон.
  var TEMPLATE = '/formBuilder/date.compile.html';

  /**
  * Выбирает даты для фильтра в таблице.
  *
  * @class WebAccess.components.dataViews.gridPlugins._controls.DateControl
  * @property {string} containerSelector Блок, содержащий выбор даты для фильтра в таблице.  
  * @property {Object} defaults Настройки по умолчанию.  
  * @since 5.2.0.1100
  */
  var DateControl = global.DateControl = BaseObject.extend({
    className: "DateControl",
    instanceID: null,
    containerSelector: '',
    state: {
      column: null,
      value: null
    },

    _jContainer: null,
    _jInput: null,

    init: function (containerSelector, defaults) {
      var me = this;
      me._super();
      me.state = {};
      $.extend(me.state, defaults);
      me.instanceID = generateUniqueID();
      me.containerSelector = containerSelector;
      me._jContainer = $(containerSelector);
      me._render();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Отрисовка компоненты.
    * @method WebAccess.components.dataViews.gridPlugins._controls.DateControl#_initControls
    * @private
    * @since 5.2.0.1100
    */
    _render: function () {
      var me = this;
      var template = WA.templates.render(TEMPLATE, {
        id: me.instanceID,
        'class': 'dateControl',
        showTime: (me.state.column.dateType === 'DateTime')
      }).done(function (html) {
        me._jContainer.html(html);
        me._initControls();
        me._bindEvents();
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Инициализация контролов компоненты.
    * @method WebAccess.components.dataViews.gridPlugins._controls.DateControl#_initControls
    * @private
    * @since 5.2.0.1100
    */
    _initControls: function () {
      var me = this;
      me._jInput = $('input.input', me.containerSelector);

      // Восстановление значения из состояния.
      me._fillInputValue();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Навершивание событий на HTML-элементы компоненты.
    * @method WebAccess.components.dataViews.gridPlugins._controls.DateControl#_bindEvents
    * @private
    * @since 5.2.0.1100
    */
    _bindEvents: function () {
      var me = this;
      me._jInput.on('change.dateControl', $.proxy(me._applyFilter, me));

      // По Enter дописываем все остальные части даты. Если ввесли только день, то дописываем месяц и год. Если ввели день и месяц, то дописываем год.
      me._jInput.on('keydown.dateControl', function (e) {
        var key = e.which || e.keyCode;
        if (key === 13) {
          var inp = me._jInput;
          var d = ParseDateTime(inp);
          inp.datepicker("setDate", d);
          inp.data('selDate', d);
          inp.change();
          me.close();
        }
      });

      var isSet = me._jInput.data('isSetBeforeShowForOpenEvent');
      if (!isSet) {
        // Изменяем функцию события beforeShow, что бы вызвать наше событие open.
        var prevBeforeShow = me._jInput.datepicker('option', 'beforeShow');
        var newBeforeShow = function () {
          if (prevBeforeShow) prevBeforeShow();
          me.fire(DateControl.EVENT.OPEN, me);
        };
        me._jInput.datepicker('option', 'beforeShow', newBeforeShow);
        me._jInput.data('isSetBeforeShowForOpenEvent', true);
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Применение выбранного значение и сохранение его в состоянии.
    * @method WebAccess.components.dataViews.gridPlugins._controls.DateControl#_applyFilter
    * @private
    * @since 5.2.0.1100
    */
    _applyFilter: function () {
      var me = this;
      var displayValue = me._jInput.val();
      if (!!displayValue) {
        me.state.value = $.toJSON(parseDate(displayValue)).replaceAll('"'); //$.toJSON возвращает дату в кавычнах, в данном случае они нам не нужны.
      } else {
        me.state.value = '';
      }
      me.fire(DateControl.EVENT.VALUE_CHANGED, me.getValue());
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Обновляет состояние поля.
    *
    * @method WebAccess.components.dataViews.gridPlugins._controls.DateControl#updateState
    * @since 5.2.0.1100
    */
    updateState: function (newState) {
      var me = this;
      $.extend(me.state, newState);
      me._fillInputValue();
      me.close();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Закрывает выпадающий список поля.
    *
    * @method WebAccess.components.dataViews.gridPlugins._controls.DateControl#close
    * @since 5.2.0.1100
    */
    close: function () {
      if (!this._jInput.length) return;
      try {
        this._jInput.datepicker('hide');
      } catch (e) {
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Установка значения input из состояния.
    * @method WebAccess.components.dataViews.gridPlugins._controls.DateControl#_fillInputValue
    * @private
    * @since 5.2.0.1100
    */
    _fillInputValue: function () {
      var me = this;
      var value = '';
      if (!!me.state.value) {
        var formatFunc = (me.state.column.dateType === 'DateTime' ? formatDateTime : formatDate);
        value = formatFunc(Date.fromISO(me.state.value));
      }
      me._jInput.val(value);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает значения поля.
    *
    * @method WebAccess.components.dataViews.gridPlugins._controls.DateControl#getValue
    * @since 5.2.0.1100
    */
    getValue: function () {
      var me = this;
      var value = {
        'Type': 'Equal',
        'Like': '',
        'In': null,
        'Equal': me.state.value
      };

      me.fire(DateControl.EVENT.GET_VALUE, me, value);

      return value;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  }, {
    EVENT: {
      GET_VALUE: 'getValue',
      VALUE_CHANGED: 'change',
      OPEN: 'open'
    }
  });
})(window.WA.components.dataViews.gridPlugins._controls);